import {Component, model, output} from '@angular/core';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';
import {FermeturePeriodeDTO} from "../../../core/dtos/client/fermeture/fermeture-periode-dto";

@Component({
  selector: 'yo-fermeture-preview-periode',
  templateUrl: './fermeture-preview-periode.component.html',
  styleUrls: ['./fermeture-preview-periode.component.scss'],
  standalone: false
})
export class FermeturePreviewPeriodeComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  visible = model(false);
  pendingLines = model<FermeturePeriodeDTO[]>([]);

  save = output();

  selectedRows: FermeturePeriodeDTO[] = [];

  onSelectionChanged(e: {selectedRowsData: FermeturePeriodeDTO[]}): void {
    this.selectedRows = e.selectedRowsData;
  }

  deleteSelected(): void {
    this.pendingLines.update(lines => lines.filter(l => !this.selectedRows.includes(l)));
    this.selectedRows = [];
  }
}
